import { RoleRecommendationMethod } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { WorkRoleListEntry } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { WorkRoleReferenceData } from '../../../../../adl-gen/totalinteraction/futurefit/requests';
import { ListFieldInfo } from '../../../common/list/list-types';

export const WorkRoleListView: ListFieldInfo<WorkRoleListEntry, WorkRoleReferenceData>[] = [
  {
    name: 'name',
    label: 'Name',
    kind: 'i18nTextLink',
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'shortname',
    label: 'Short Name',
    kind: 'i18nText',
    displayed: true,
    sortable: true
  },
  {
    name: 'owner',
    label: 'Global/Client',
    kind: 'mapped',
    map: entry => {
      if (entry.owner.kind === 'global') {
        return 'global';
      } else {
        return entry.appClient ? entry.appClient.name : 'notfound';
      }
    },
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'recommendationMethod',
    label: 'Recommendation Method',
    kind: 'mapped',
    map: entry =>
      entry.recommendationMethod === RoleRecommendationMethod.relevance ? 'relevance' : 'role/competency/range',
    displayed: true,
    sortable: true
  },
  {
    name: 'recommendationProviders',
    label: 'Recommendation Providers',
    kind: 'selectList',
    map: (entry, data: WorkRoleReferenceData) => {
      if (entry.recommendationProviders.length === 0) {
        return [{ label: 'None', value: '' }];
      }
      return entry.recommendationProviders.map(rp => {
        if (rp.length === 0) {
          return { label: 'None', value: '' };
        }
        const provider = data.providerList.find(p => p.id === rp);
        return { label: provider ? provider.value.name : 'notfound', value: rp };
      });
    },
    displayed: true
  }
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/workrole-list/workrole-list-view.ts